var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDescendingOrder18 = function SvgIconDescendingOrder18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.903 5.408 8.552 5.39l.004-1.125 5.351.018-.004 1.125ZM11.175 9.676H8.554V8.55h2.621v1.125ZM12.735 7.535H8.554V6.41h4.181v1.125ZM6.049 13.474V4.249h1.275v9.225H6.049Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.896 14.048-2.267-2.38.923-.88 2.133 2.24 2.134-2.24.923.88-2.268 2.38a1.086 1.086 0 0 1-1.578 0Zm.926-.877.002.002-.002-.002Z",
    fill: "current"
  })));
};
export default SvgIconDescendingOrder18;